import {defineAsyncComponent} from 'vue'
const KocRouter = [
  {
    path: 'koc_account',
    name: 'KocAccount',
    component: () => import('@/views/Kocs/KocAccount/Index.vue'),
    meta: {
      key: 'koc'
    }
  },
  {
    path: 'douyin_datas',
    name: 'DouyinDatas',
    component: () => import('@/views/Kocs/DouyinDatas/Index.vue'),
    meta: {
      key: 'koc'
    }
  },
]
export {KocRouter}
